// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__32fba","inner":"Footer_inner__2EBTp"};